/**
 * Servicio que conecta con la API los comentarios de las tareas
 */
ComentarioTareaDataService.$inject = ['$resource'];

export default function ComentarioTareaDataService($resource) {
    return $resource(Sigo.var.path + '/api/v1' + '/tareas' + '/:tareaId/comentarios/:comentarioId', {
            tareaId: '@tareaId',
            comentarioId: '@comentarioId'
        }, {
            'update': {method: 'PUT'}
        }
    );
}